module.exports = __webpack_public_path__ + "static/media/play-circle.6000b5ef.svg";